"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var FormControl_style_1 = __importDefault(require("./FormControl.style"));
var utils_1 = require("@prezzee/utils");
var FormControlContext_1 = __importDefault(require("./FormControlContext"));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */
var FormControl = (0, react_1.forwardRef)(function (props, ref) {
    var children = props.children, className = props.className, 
    // component = 'div',
    _a = props.disabled, 
    // component = 'div',
    disabled = _a === void 0 ? false : _a, _b = props.error, error = _b === void 0 ? false : _b, visuallyFocused = props.focused, _c = props.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = props.hiddenLabel, hiddenLabel = _d === void 0 ? false : _d, _e = props.margin, margin = _e === void 0 ? 'none' : _e, _f = props.required, required = _f === void 0 ? false : _f, _g = props.size, size = _g === void 0 ? 'medium' : _g, _h = props.variant, variant = _h === void 0 ? 'outlined' : _h, rest = __rest(props, ["children", "className", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"]);
    var inputNames = ['PrezzeeInput', 'PrezzeeOutlinedInput', 'PrezzeeFilledInput'];
    var _j = __read((0, react_1.useState)(function () {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialAdornedStart = false;
        if (children) {
            react_1.Children.forEach(children, function (child) {
                var _a;
                if (!(0, utils_1.isPrezzeeElement)(child, __spreadArray(__spreadArray([], __read(inputNames), false), ['PrezzeeSelect'], false))) {
                    return;
                }
                // @ts-ignore
                var input = (0, utils_1.isPrezzeeElement)(child, ['PrezzeeSelect']) ? child.props.input : child;
                if (input && ((_a = input === null || input === void 0 ? void 0 : input.props) === null || _a === void 0 ? void 0 : _a.startAdornment)) {
                    initialAdornedStart = true;
                }
            });
        }
        return initialAdornedStart;
    }), 2), adornedStart = _j[0], setAdornedStart = _j[1];
    var _k = __read((0, react_1.useState)(function () {
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        var initialFilled = false;
        if (children) {
            react_1.Children.forEach(children, function (child) {
                if (!(0, utils_1.isPrezzeeElement)(child, __spreadArray(__spreadArray([], __read(inputNames), false), ['PrezzeeSelect'], false))) {
                    return;
                }
                if ((0, react_1.isValidElement)(child) && (0, utils_1.isFilled)(child === null || child === void 0 ? void 0 : child.props, true)) {
                    initialFilled = true;
                }
            });
        }
        return initialFilled;
    }), 2), filled = _k[0], setFilled = _k[1];
    var _l = __read((0, react_1.useState)(false), 2), focusedState = _l[0], setFocused = _l[1];
    if (disabled && focusedState) {
        setFocused(false);
    }
    var focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    var registerEffect;
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var registeredInput_1 = (0, react_1.useRef)(false);
        registerEffect = function () {
            if (registeredInput_1.current) {
                console.error([
                    'There are multiple `InputBase` components inside a FormControl.',
                    'This creates visual inconsistencies, only use one `InputBase`.',
                ].join('\n'));
            }
            registeredInput_1.current = true;
            return function () {
                registeredInput_1.current = false;
            };
        };
    }
    var onFilled = (0, react_1.useCallback)(function () {
        setFilled(true);
    }, []);
    var onEmpty = (0, react_1.useCallback)(function () {
        setFilled(false);
    }, []);
    var childContext = {
        adornedStart: adornedStart,
        setAdornedStart: setAdornedStart,
        // color,
        disabled: disabled,
        error: error,
        filled: filled,
        focused: focused,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        size: size,
        onBlur: function () {
            setFocused(false);
        },
        onEmpty: onEmpty,
        onFilled: onFilled,
        onFocus: function () {
            setFocused(true);
        },
        registerEffect: registerEffect,
        required: required,
        variant: variant,
    };
    var FormControlRoot = 'div';
    return ((0, jsx_runtime_1.jsx)(FormControlContext_1.default.Provider, __assign({ value: childContext }, { children: (0, jsx_runtime_1.jsx)(FormControlRoot, __assign({ css: (0, FormControl_style_1.default)(fullWidth), className: className, ref: ref }, rest, { children: children })) })));
});
exports.default = FormControl;
//# sourceMappingURL=FormControl.js.map